module.exports = __webpack_public_path__ + "assets/img/18.344070fa.png";